import React, { useMemo, useState, useRef } from "react";
import "../../styles/master-data.css";

export default function MasterDataWorkspace({
  title = "Master Data",
  columns = [],
  rows = [],
  loading = false,
  onCreate,
  onEdit,
  onRefresh,
  onImport,
  onExport,
  onToggleStatus,
}) {
  const [query, setQuery] = useState("");
  const [status, setStatus] = useState("ALL");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const fileRef = useRef(null);

  const filtered = useMemo(() => rows.filter((row) => {
    const text = columns.map((c) => row[c.key]).join(" ").toLowerCase();
    return (!query || text.includes(query.toLowerCase())) &&
      (status === "ALL" || String(row.status).toUpperCase() === status);
  }), [rows, columns, query, status]);

  const pages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const current = Math.min(page, pages);
  const data = filtered.slice((current - 1) * pageSize, current * pageSize);

  return (
    <section className="mdw">
      <header className="mdw-head">
        <div>
          <small>Pusat Data / {title}</small>
          <h1>{title}</h1>
        </div>
        <button className="mdw-primary" onClick={onCreate}>＋ Data Baru</button>
      </header>

      <div className="mdw-toolbar">
        <select value={status} onChange={(e) => {setStatus(e.target.value);setPage(1);}}>
          <option value="ALL">Status: Semua</option>
          <option value="ACTIVE">Aktif</option>
          <option value="INACTIVE">Nonaktif</option>
        </select>
        <input placeholder="Cari kode atau nama..." value={query}
          onChange={(e) => {setQuery(e.target.value);setPage(1);}} />
        <button onClick={onRefresh} disabled={loading}>↻ Refresh</button>
        <button onClick={() => fileRef.current?.click()}>Import CSV</button>
        <input ref={fileRef} type="file" accept=".csv,text/csv"
          hidden onChange={e => {
            const file = e.target.files?.[0];
            if (file) onImport?.(file);
            e.target.value = "";
          }} />
        <button onClick={onExport}>Export CSV</button>
      </div>

      <div className="mdw-card">
        <div className="mdw-scroll">
          <table>
            <thead><tr>
              {columns.map(c => <th key={c.key}>{c.label}</th>)}
              <th>Aksi</th>
            </tr></thead>
            <tbody>
              {loading ? <tr><td colSpan={columns.length+1}>Memuat…</td></tr> :
                data.length ? data.map(row => <tr key={row.id}>
                  {columns.map(c => <td key={c.key}>{row[c.key] ?? "—"}</td>)}
                  <td className="mdw-actions">
                    <button onClick={() => onEdit?.(row)}>Detail/Edit</button>
                    <button onClick={() => onToggleStatus?.(row)}>
                      {row.status === "ACTIVE" ? "Nonaktifkan" : "Aktifkan"}
                    </button>
                  </td>
                </tr>) :
                <tr><td className="mdw-empty" colSpan={columns.length+1}>Belum ada data.</td></tr>}
            </tbody>
          </table>
        </div>
        <footer className="mdw-foot">
          <span>{filtered.length} data · halaman {current}/{pages}</span>
          <div>
            <select value={pageSize} onChange={e => {setPageSize(+e.target.value);setPage(1);}}>
              <option value="20">20/halaman</option>
              <option value="50">50/halaman</option>
              <option value="100">100/halaman</option>
            </select>
            <button disabled={current===1} onClick={() => setPage(current-1)}>‹</button>
            <button disabled={current===pages} onClick={() => setPage(current+1)}>›</button>
          </div>
        </footer>
      </div>
    </section>
  );
}
